import React, { useMemo, useState } from 'react';
import Covenants from './Covenants';
import SecuritiesAndGuarantees from './SecuritiesAndGuarantees';

const tabs: { title: string; tab: 'SG' | 'C' }[] = [
    {
        tab: 'SG',
        title: 'Securities/Guarantees',
    },
    {
        tab: 'C',
        title: 'Covenants',
    },
];

const BookingInformation: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'SG' | 'C'>('SG');

    const component = useMemo(() => {
        switch (activeTab) {
            case 'SG':
                return <SecuritiesAndGuarantees />;
            case 'C':
                return <Covenants />;
            default:
                return null;
        }
    }, [activeTab]);

    return (
        <div className="px-6 pb-4">
            <div className="flex items-center">
                {tabs.map((t, index) => (
                    <div
                        key={`${t.tab}_${index}`}
                        className="px-4 py-2 text-sm WorkSans font-medium mr-2 rounded-full cursor-pointer"
                        style={
                            activeTab === t.tab
                                ? { backgroundColor: '#16365C', color: 'white' }
                                : { backgroundColor: '#F4F7FD', color: '#777777' }
                        }
                        onClick={() => setActiveTab(t.tab)}
                    >
                        {t.title}
                    </div>
                ))}
            </div>
            <div>{component}</div>
        </div>
    );
};

export default BookingInformation;
